import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private storageSub = new Subject<{ key: string, value: any }>();

  watchStorage() {
    return this.storageSub.asObservable();
  }

  setItem(key: string, value: any) {
    localStorage.setItem(key, value);
    this.storageSub.next({ key, value });
  }

  getItem(key: string) {
    return localStorage.getItem(key);
  }
}
